<template>
  <div class="home-slider">
    <Carousel :per-page="1" :mouseDrag="true" :paginationEnabled="false" :autoplay="true" :loop="true">
      <Slide v-for="(slide, index) in sliders" :key="index">
        <div class="slider-pic" :style="{'background-image' : `url(${slide.bck})`}">
            <div class="container">
              <div class="slider-content">
                  <!-- <app-button type="link" linkTo="#" :addClass="['btn', 'btn-primary']">See review</app-button> -->
                <!-- <h1>{{ slide.title }}</h1>
                <p>{{ slide.dec}}</p> -->
              </div>
            </div>
        </div>
      </Slide>
    </Carousel>
  </div>
</template>

<script>
import { Carousel, Slide } from "vue-carousel";

import SlideOne from "./../../assets/images/featured/slider01.jpg";
import SlideTwo from "./../../assets/images/featured/slider02.jpg";
import SlideThree from "./../../assets/images/featured/slider03.jpg";
import SlideFour from "./../../assets/images/featured/slider04.jpg";
import SlideFive from "./../../assets/images/featured/slider05.jpg";

export default {
  data() {
    return {
      sliders: [
        {
          title: "Red dead redemption",
          dec:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
          bck: SlideOne
        },
        {
          title: "Watchdog 2",
          bck: SlideTwo
        },
        {
          title: "Rise of tomb rider",
          bck: SlideThree
        },
        {
          title: "Need For Speed Rivals",
          bck: SlideFour
        },
        {
          title: "PubG",
          bck: SlideFive
        },
      ]
    };
  },
  components: {
    Carousel,
    Slide
  },
  computed:{
    navigationNext: function() { return `<i class="fas fa-chevron-right"></i>` },
    navigationPrev: function() { return `<i class="fas fa-chevron-left"></i>` }
  }
};
</script>